export default __webpack_public_path__ + "static/media/list_03_img.ac9baeec.png";